import { useMemo } from 'react';
import { matchPath, useRouteMatch } from 'react-router-dom';
import { LinkTo } from 'shared/constants/linkTo';
import { AppTester, AppTesterType } from 'supporting';

const IMAGES = {
  portfolioArtz: 'artz.work.jpg',
  hsedesign: 'hsedesign.ru.jpg',
  kiiids: 'kiiids.art.jpg',
  hseSpace: 'hse.space.jpg',
  hseBiotech: 'hsebiotech.png',
  greenAward: 'green-award.ru.jpg',
  brnd: 'brnd.ru.jpg',
  deziiign: 'deziiign.com.jpg',
  portfolio365: 'portfolio365.ru.jpg',
  booksDeziiign: 'books.deziiign.ru.jpg',
  urbanDeziiign: 'books.deziiign.ru-1.jpg',
  cgrave: 'cgrave.ru.jpg',
  ageytomesh: 'ageytomesh.com.jpg',
  galllleryArt: 'gallllery.art.jpg',
  lmsHsedesign: 'lms.hsedesign.ru.jpg',
  gallllery: 'gallllery.com.jpg',
  // dafes: 'dafes.net.jpg',
  dafes1: 'dafes.net-1.jpg',
  fashionDeziiign: 'fashion.deziiign.ru.jpg',
  proDeziiign: 'pro.deziiign.ru.jpg',
  gameDeziiign: 'game.deziiign.ru.jpg',
  continuum: 'continuum.site.jpg',
  mediiia: 'mediiia.com.jpg',
  mediiia365: '365.png',
  mediiiaFood: 'food.png',
  mediiiaCine: 'cine.png',
  mediiiaAi: 'ai.png',
  mediiiaSound: 'sound.png',
  mediiiaPhoto: 'photo.png',
  mediiiaArt: 'art.png',
  mediiiaKiiids: 'mediiia.com.jpg',
  mediiiaHistory: 'history.png',
  mediiiaAuto: 'auto.png',
  dva: 'dva.design.jpg',
  creativeHse: 'creativehse.jpg',
  monalisatravels: 'monalisatravels.com.jpg',
  hseanimation: 'hseanimation.jpg',
  promptWeekend: 'prompt-weekend.jpg',
  creativeCity: 'creativecity.academy.png',
  aki: 'aki.png',
  // ftbl: 'ftbl.com.jpg'
} as const;

const getUrlForMetaImage = (AppTester: AppTesterType, path: string,exludesCondition?: boolean) => {
  if (exludesCondition) {
    return 'https://mediiia.com/og/art-residents.jpg'
  }
  if (AppTester.isPortfolioArtz()) {
    return process.env.REACT_APP_URL_ARTZ + '/images/' + 'hsedesign.ru.jpg';
  }
  return `${window.location.origin}/brg/meta/${path}`;;
}

export const getMetaImage = (AppTester: AppTesterType, pathname?: string) => {
  const isPromptWeekend = pathname === '/prompt-weekend';

  const isMediiiaResidentsPage = 
    !!matchPath(pathname || '', { path: LinkTo.residents, exact: true }) || 
    !!matchPath(pathname || '', { path: LinkTo.specialProjects, exact: true }) ||
    !!matchPath(pathname || '', { path: LinkTo.partners, exact: true });
  

  if (AppTester.isFr() || AppTester.isOnlinesDesign() || AppTester.isUz()) {
    return null;
  }
  if (AppTester.isPortfolioArtz()) {
    return IMAGES.portfolioArtz;
  }
  if (isPromptWeekend) {
    return IMAGES.promptWeekend;
  }
  if (AppTester.isAKI()) {
    return IMAGES.aki;
  }
  if (AppTester.isCreativeHSE()) {
    return IMAGES.creativeHse;
  }
  if (AppTester.isLMSHSE()) {
    return IMAGES.lmsHsedesign;
  }
  if (AppTester.isHSEBiotech()) {
    return IMAGES.hseBiotech;
  }
  if (AppTester.isHseSpace()) {
    return IMAGES.hseSpace;
  }
  if (AppTester.isHseAnimation()) {
    return IMAGES.hseanimation;
  }
  if (AppTester.isHSEDesign()) {
    return IMAGES.hsedesign;
  }
  if (AppTester.isGalllleryArt()) {
    return IMAGES.galllleryArt;
  }
  if (AppTester.isBooksGallllery()) {
    return IMAGES.gallllery;
  }
  if (AppTester.isCGRAVE()) {
    return IMAGES.cgrave;
  }
  if (AppTester.isGameDeziiign()) {
    return IMAGES.gameDeziiign;
  }
  if (AppTester.isFashionDeziiign()) {
    return IMAGES.fashionDeziiign;
  }
  if (AppTester.isContext('pro')) {
    return IMAGES.proDeziiign;
  }
  if (AppTester.isBooksDeziiign()) {
    return IMAGES.booksDeziiign;
  }
  if (AppTester.isPortfolio365()) {
    return IMAGES.portfolio365;
  }
  if (AppTester.isKiiidsArt()) {
    return IMAGES.kiiids;
  }
  if (AppTester.isBrnd()) {
    return IMAGES.brnd;
  }
  if (AppTester.isDvaDesign()) {
    return IMAGES.dva;
  }
  if (AppTester.isGreenAward()) {
    return IMAGES.greenAward;
  }
  if (AppTester.isLectureMediiia()) {
    if (isMediiiaResidentsPage) {
      return ''
    }
  }
  if (AppTester.isMediiia()) {

    if (isMediiiaResidentsPage) {
      if (AppTester.isMediiiaMain()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isMediiiaStories()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isMediiiaNature()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isMediiiaSport()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isMediiiaProf()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isMediiiaCine()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isMediiiaAi()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isMediiiaArt()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isMediiiaKiiids()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isMediiiaFood()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isMediiiaAuto()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isMediiiaConcept()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isHistoryMediiia()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isMusicMediiia()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isMediiia365() || AppTester.isEventMediiia()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isMyMediiia()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isMyMediiia()) {
        return 'art-residents.jpg'
      }
    }

    if (AppTester.isEventMediiia()) {
      return IMAGES.mediiia365;
    }
    if (AppTester.isMediiiaFood()) {
      return IMAGES.mediiiaFood;
    }
    if (AppTester.isMediiiaCine()) {
      return IMAGES.mediiiaCine;
    }
    if (AppTester.isMediiiaAi()) {
      return IMAGES.mediiiaAi;
    }
    if (AppTester.isMusicMediiia()) {
      return IMAGES.mediiiaSound;
    }
    if (AppTester.isMediiiaArt()) {
      return IMAGES.mediiiaArt;
    }
    if (AppTester.isMediiiaKiiids()) {
      return IMAGES.mediiiaKiiids;
    }
    if (AppTester.isHistoryMediiia()) {
      return IMAGES.mediiiaHistory;
    }
    if (AppTester.isMediiiaAuto()) {
      return IMAGES.mediiiaAuto;
    }
    return IMAGES.mediiia;
  }
  if (AppTester.isAgeytomesh()) {
    return IMAGES.ageytomesh;
  }
  if (AppTester.isContinuumSite()) {
    return IMAGES.continuum;
  }
  if (AppTester.isGeoDafes()) {
    return IMAGES.dafes1;
  }
  if (AppTester.isMediiiaUrban()) {
    return IMAGES.urbanDeziiign;
  }
  if (AppTester.isMonaLisaTravels()) {
    return IMAGES.monalisatravels;
  }
  if (AppTester.isAcademy()) {
    return IMAGES.creativeCity;
  }
  if (AppTester.isDeziiign() || AppTester.isCompetition()) {
    return IMAGES.deziiign;
  }
  return null;
}

const useMetaImage = () => {
  const isProjectPage = !!useRouteMatch('/project');
  const isDesignerPage = !!useRouteMatch('/designer');
  const isTeamPage = !!useRouteMatch('/teams/:id');
  const isCompetitionPage = !!useRouteMatch('/competition/:id');
  const isTagPage = !!useRouteMatch(LinkTo.tag);

  const isMediiiaResidentsPage = 
    (AppTester.isMediiia() || AppTester.isLectureMediiia()) && 
    !!useRouteMatch([LinkTo.residents, LinkTo.specialProjects])

  const imagePath = useMemo(() => {
  
    return getMetaImage(AppTester);
  }, []);

  if (!imagePath) {
    return null;
  }

  const imageUrl = useMemo(() => {
    return getUrlForMetaImage(AppTester, imagePath, isMediiiaResidentsPage);
  }, [imagePath, isMediiiaResidentsPage]);

  const shouldDisplayMeta = !isProjectPage && !isDesignerPage && !isTeamPage && !isCompetitionPage && !isTagPage;

  return shouldDisplayMeta && [
    <meta key="vk" property="vk:image" content={imageUrl} />,
    <meta key="og" property="og:image" content={imageUrl} />,
    ...(isMediiiaResidentsPage ? [
    <meta property="og:image:width" content="1200" />,
    <meta property="og:image:height" content="630" />
    ] : []),
    <meta key="twitter" name="twitter:image" content={imageUrl} />,
    <meta name="twitter:card" content="summary_large_image" />
  ];
};

export default useMetaImage;import { useMemo } from 'react';
import { matchPath, useRouteMatch } from 'react-router-dom';
import { LinkTo } from 'shared/constants/linkTo';
import { AppTester, AppTesterType } from 'supporting';

const IMAGES = {
  portfolioArtz: 'artz.work.jpg',
  hsedesign: 'hsedesign.ru.jpg',
  kiiids: 'kiiids.art.jpg',
  hseSpace: 'hse.space.jpg',
  hseBiotech: 'hsebiotech.png',
  greenAward: 'green-award.ru.jpg',
  brnd: 'brnd.ru.jpg',
  deziiign: 'deziiign.com.jpg',
  portfolio365: 'portfolio365.ru.jpg',
  booksDeziiign: 'books.deziiign.ru.jpg',
  urbanDeziiign: 'books.deziiign.ru-1.jpg',
  cgrave: 'cgrave.ru.jpg',
  ageytomesh: 'ageytomesh.com.jpg',
  galllleryArt: 'gallllery.art.jpg',
  lmsHsedesign: 'lms.hsedesign.ru.jpg',
  gallllery: 'gallllery.com.jpg',
  // dafes: 'dafes.net.jpg',
  dafes1: 'dafes.net-1.jpg',
  fashionDeziiign: 'fashion.deziiign.ru.jpg',
  proDeziiign: 'pro.deziiign.ru.jpg',
  gameDeziiign: 'game.deziiign.ru.jpg',
  continuum: 'continuum.site.jpg',
  mediiia: 'mediiia.com.jpg',
  mediiia365: '365.png',
  mediiiaFood: 'food.png',
  mediiiaCine: 'cine.png',
  mediiiaAi: 'ai.png',
  mediiiaSound: 'sound.png',
  mediiiaPhoto: 'photo.png',
  mediiiaArt: 'art.png',
  mediiiaKiiids: 'mediiia.com.jpg',
  mediiiaHistory: 'history.png',
  mediiiaAuto: 'auto.png',
  dva: 'dva.design.jpg',
  creativeHse: 'creativehse.jpg',
  monalisatravels: 'monalisatravels.com.jpg',
  hseanimation: 'hseanimation.jpg',
  promptWeekend: 'prompt-weekend.jpg',
  creativeCity: 'creativecity.academy.png',
  aki: 'aki.png',
  // ftbl: 'ftbl.com.jpg'
} as const;

const getUrlForMetaImage = (AppTester: AppTesterType, path: string,exludesCondition?: boolean) => {
  if (exludesCondition) {
    return 'https://mediiia.com/og/art-residents.jpg'
  }
  if (AppTester.isPortfolioArtz()) {
    return process.env.REACT_APP_URL_ARTZ + '/images/' + 'hsedesign.ru.jpg';
  }
  return `${window.location.origin}/brg/meta/${path}`;;
}

export const getMetaImage = (AppTester: AppTesterType, pathname?: string) => {
  const isPromptWeekend = pathname === '/prompt-weekend';

  const isMediiiaResidentsPage = 
    !!matchPath(pathname || '', { path: LinkTo.residents, exact: true }) || 
    !!matchPath(pathname || '', { path: LinkTo.specialProjects, exact: true }) ||
    !!matchPath(pathname || '', { path: LinkTo.partners, exact: true });
  

  if (AppTester.isFr() || AppTester.isOnlinesDesign() || AppTester.isUz()) {
    return null;
  }
  if (AppTester.isPortfolioArtz()) {
    return IMAGES.portfolioArtz;
  }
  if (isPromptWeekend) {
    return IMAGES.promptWeekend;
  }
  if (AppTester.isAKI()) {
    return IMAGES.aki;
  }
  if (AppTester.isCreativeHSE()) {
    return IMAGES.creativeHse;
  }
  if (AppTester.isLMSHSE()) {
    return IMAGES.lmsHsedesign;
  }
  if (AppTester.isHSEBiotech()) {
    return IMAGES.hseBiotech;
  }
  if (AppTester.isHseSpace()) {
    return IMAGES.hseSpace;
  }
  if (AppTester.isHseAnimation()) {
    return IMAGES.hseanimation;
  }
  if (AppTester.isHSEDesign()) {
    return IMAGES.hsedesign;
  }
  if (AppTester.isGalllleryArt()) {
    return IMAGES.galllleryArt;
  }
  if (AppTester.isBooksGallllery()) {
    return IMAGES.gallllery;
  }
  if (AppTester.isCGRAVE()) {
    return IMAGES.cgrave;
  }
  if (AppTester.isGameDeziiign()) {
    return IMAGES.gameDeziiign;
  }
  if (AppTester.isFashionDeziiign()) {
    return IMAGES.fashionDeziiign;
  }
  if (AppTester.isContext('pro')) {
    return IMAGES.proDeziiign;
  }
  if (AppTester.isBooksDeziiign()) {
    return IMAGES.booksDeziiign;
  }
  if (AppTester.isPortfolio365()) {
    return IMAGES.portfolio365;
  }
  if (AppTester.isKiiidsArt()) {
    return IMAGES.kiiids;
  }
  if (AppTester.isBrnd()) {
    return IMAGES.brnd;
  }
  if (AppTester.isDvaDesign()) {
    return IMAGES.dva;
  }
  if (AppTester.isGreenAward()) {
    return IMAGES.greenAward;
  }
  if (AppTester.isLectureMediiia()) {
    if (isMediiiaResidentsPage) {
      return ''
    }
  }
  if (AppTester.isMediiia()) {

    if (isMediiiaResidentsPage) {
      if (AppTester.isMediiiaMain()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isMediiiaStories()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isMediiiaNature()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isMediiiaSport()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isMediiiaProf()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isMediiiaCine()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isMediiiaAi()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isMediiiaArt()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isMediiiaKiiids()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isMediiiaFood()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isMediiiaAuto()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isMediiiaConcept()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isHistoryMediiia()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isMusicMediiia()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isMediiia365() || AppTester.isEventMediiia()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isMyMediiia()) {
        return 'art-residents.jpg'
      }
      if (AppTester.isMyMediiia()) {
        return 'art-residents.jpg'
      }
    }

    if (AppTester.isEventMediiia()) {
      return IMAGES.mediiia365;
    }
    if (AppTester.isMediiiaFood()) {
      return IMAGES.mediiiaFood;
    }
    if (AppTester.isMediiiaCine()) {
      return IMAGES.mediiiaCine;
    }
    if (AppTester.isMediiiaAi()) {
      return IMAGES.mediiiaAi;
    }
    if (AppTester.isMusicMediiia()) {
      return IMAGES.mediiiaSound;
    }
    if (AppTester.isMediiiaArt()) {
      return IMAGES.mediiiaArt;
    }
    if (AppTester.isMediiiaKiiids()) {
      return IMAGES.mediiiaKiiids;
    }
    if (AppTester.isHistoryMediiia()) {
      return IMAGES.mediiiaHistory;
    }
    if (AppTester.isMediiiaAuto()) {
      return IMAGES.mediiiaAuto;
    }
    return IMAGES.mediiia;
  }
  if (AppTester.isAgeytomesh()) {
    return IMAGES.ageytomesh;
  }
  if (AppTester.isContinuumSite()) {
    return IMAGES.continuum;
  }
  if (AppTester.isGeoDafes()) {
    return IMAGES.dafes1;
  }
  if (AppTester.isMediiiaUrban()) {
    return IMAGES.urbanDeziiign;
  }
  if (AppTester.isMonaLisaTravels()) {
    return IMAGES.monalisatravels;
  }
  if (AppTester.isAcademy()) {
    return IMAGES.creativeCity;
  }
  if (AppTester.isDeziiign() || AppTester.isCompetition()) {
    return IMAGES.deziiign;
  }
  return null;
}

const useMetaImage = () => {
  const isProjectPage = !!useRouteMatch('/project');
  const isDesignerPage = !!useRouteMatch('/designer');
  const isTeamPage = !!useRouteMatch('/teams/:id');
  const isCompetitionPage = !!useRouteMatch('/competition/:id');
  const isTagPage = !!useRouteMatch(LinkTo.tag);

  const isMediiiaResidentsPage = 
    (AppTester.isMediiia() || AppTester.isLectureMediiia()) && 
    !!useRouteMatch([LinkTo.residents, LinkTo.specialProjects])

  const imagePath = useMemo(() => {
  
    return getMetaImage(AppTester);
  }, []);

  if (!imagePath) {
    return null;
  }

  const imageUrl = useMemo(() => {
    return getUrlForMetaImage(AppTester, imagePath, isMediiiaResidentsPage);
  }, [imagePath, isMediiiaResidentsPage]);

  const shouldDisplayMeta = !isProjectPage && !isDesignerPage && !isTeamPage && !isCompetitionPage && !isTagPage;

  return shouldDisplayMeta && [
    <meta key="vk" property="vk:image" content={imageUrl} />,
    <meta key="og" property="og:image" content={imageUrl} />,
    ...(isMediiiaResidentsPage ? [
    <meta property="og:image:width" content="1200" />,
    <meta property="og:image:height" content="630" />
    ] : []),
    <meta key="twitter" name="twitter:image" content={imageUrl} />,
    <meta name="twitter:card" content="summary_large_image" />
  ];
};

export default useMetaImage;